import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './app/queryClient.js';
import { Providers } from './app/providers.jsx';
import { ErrorBoundary } from './app/ErrorBoundary.jsx';
import { AppRouter } from './app/router.jsx';
import { ToastViewport } from './layout/Toast.jsx';

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Providers>
            <AppRouter />
            <ToastViewport />
          </Providers>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
